import React from "react";
import { Crown } from "lucide-react";
import { usePrefs } from "@/contexts/PrefsContext";
import type { Price } from "@/types";

export const SEATING = ["general", "vip", "family", "youth", "ladies"] as const;
export type Seating = (typeof SEATING)[number];

export const fmtPrice = (p: Price) => `${Number(p.amount).toLocaleString("en-US", { minimumFractionDigits: p.currency === "USD" ? 2 : 0, maximumFractionDigits: p.currency === "USD" ? 2 : 0 })} ${p.currency}`;

export const SeatingBadge = ({ s, testId }: { s?: string | null; testId?: string }) => {
  const { t } = usePrefs();
  if (!s) return null;
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-bold ${s === "vip" ? "bg-amber-400 text-amber-950" : "bg-accent"}`}>
      {s === "vip" && <Crown className="h-3 w-3" />}{t(`seat.${s}`)}
    </span>
  );
};

export const vipFeeText = (fee: Price, per: string | null | undefined, t: (k: string) => string) => `+${fmtPrice(fee)} ${t(per === "booking" ? "seat.perBooking" : "seat.perPerson")}`;
